// @flow
import * as React from 'react';

import { AlertContainer, AlertIcon, Close, IconContainer, Message } from './styles';

import { alerts } from '~/core/constants';
import generalIcons from '~/core/constants/icons/general-svg';

type Props = {
    children: React$Node,
    dismissable: boolean,
    id?: number,
    onDismiss?: (id: number) => void,
    type: string
};

export default function Alert({ children, id, dismissable = false, onDismiss, type, ...props }: Props) {
    const isError = type === alerts.types.ERROR;
    const isSuccess = type === alerts.types.SUCCESS;
    const isWarning = type === alerts.types.WARNING;

    const iconTypeMap = new Map([
        [true, generalIcons.INFO],
        [isError, generalIcons.EXCLAMATION],
        [isSuccess, generalIcons.TICK_ONE]
    ]);

    return (
        <AlertContainer {...props} error={isError} success={isSuccess} warning={isWarning}>
            <IconContainer>
                <AlertIcon type={iconTypeMap.get(true)} />
            </IconContainer>
            <Message>{children}</Message>
            {dismissable && (
                <Close onClick={() => onDismiss && typeof id === 'number' && onDismiss(id)} type="button">
                    <IconContainer>
                        <AlertIcon type={generalIcons.CLOSE} />
                    </IconContainer>
                </Close>
            )}
        </AlertContainer>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/alert/index.js